<template>
  <div>
    <b-card
      no-body
      class="my-0"
      :class="{ 'card-transparent-background': type == 'register' }"
    >
      <b-card-header v-if="type == 'view'" class="card-header-profile-border">
        <b-row>
          <b-col> <h4>Order Numbeer</h4></b-col>
          <b-col class="text-right"
            ><h4 class="orderNumber">#{{ order_number }}</h4>
            <span :class="'orderStatusSpan ' + status + '_status'">{{
              status_str
            }}</span></b-col
          >
        </b-row>
      </b-card-header>
      <b-card-header
        v-else
        :class="{
          'card-header-profile-border':
            type == 'profile' || type == 'edit' || type == 'add',
          'card-header-form-doorder': type == 'register',
        }"
        ><h4>Customer Details</h4></b-card-header
      >

      <b-card-body
        class=""
        :class="{
          'p-2': type == 'profile' || type == 'edit',
          'py-0': type == 'register',
        }"
      >
        <div class="container">
          <b-row>
            <b-col sm="6" v-if="type != 'view'">
              <b-form-group
                class="form-group-doorder"
                label="First name"
                label-for="first_name"
                :first_name="first_name"
                label-class="form-label-doorder"
              >
                <template v-slot:label v-if="type != 'view'">
                  First name <span class="requiredIconSpan">*</span>
                </template>
                <p v-if="invalid_first_name" class="error_validation_message_p">
                  Please enter first name
                </p>
                <b-form-input
                  v-if="type == 'add' || type == 'edit'"
                  id="first_name"
                  class="form-control-doorder"
                  v-model="_first_name"
                  :first_name="first_name"
                  placeholder="First name"
                  required
                ></b-form-input>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _first_name }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="6" v-if="type != 'view'">
              <b-form-group
                class="form-group-doorder"
                label="Last name"
                label-for="last_name"
                :last_name="last_name"
                label-class="form-label-doorder"
              >
                <template v-slot:label>
                  Last name <span class="requiredIconSpan">*</span>
                </template>
                <p v-if="invalid_last_name" class="error_validation_message_p">
                  Please enter last name
                </p>
                <b-form-input
                  v-if="type == 'add' || type == 'edit'"
                  id="last_name"
                  class="form-control-doorder"
                  v-model="_last_name"
                  :last_name="last_name"
                  placeholder="Last name"
                  required
                ></b-form-input>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _last_name }}
                </span>
              </b-form-group>
            </b-col>
            <b-col :sm="type == 'view' ? '12' : '6'" v-if="type == 'view'">
              <b-form-group
                class="form-group-doorder"
                label="Name"
                label-for="last_name"
                :last_name="last_name"
                label-class="form-label-doorder"
              >
                <span class="form-control form-control-doorder">
                  {{ customer_name }}
                </span>
              </b-form-group>
            </b-col>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Email"
                label-for="email"
                :email="email"
                label-class="form-label-doorder"
                ><p v-if="invalid_email" class="error_validation_message_p">
                  Please enter email
                </p>
                <b-form-input
                  v-if="type == 'add' || type == 'edit'"
                  id="email"
                  class="form-control-doorder"
                  v-model="_email"
                  :email="email"
                  placeholder="Email"
                ></b-form-input>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _email }}
                </span>
              </b-form-group>
            </b-col>

            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="mobile-number-input-group-doorder"
                label="Contact number"
                label-for="contact_number"
                :contact_number="contact_number"
                label-class="form-label-doorder"
              >
                <template v-slot:label v-if="type != 'view'">
                  Contact number <span class="requiredIconSpan">*</span>
                </template>
                <p
                  v-if="invalid_contact_number"
                  class="error_validation_message_p"
                >
                  Please enter contact number
                </p>

                <vue-tel-input
                  v-if="type == 'add' || type == 'edit'"
                  class="form-control form-control-doorder"
                  id="contact_number"
                  v-model="_contact_number"
                  :contact_number="contact_number"
                  required
                ></vue-tel-input>

                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _contact_number }}
                </span>
              </b-form-group>
            </b-col>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                label="Address"
                label-for="dropoff_address"
                label-class="form-label-doorder"
                class="h-100 form-group-textarea-doorder form-group-doorder"
              >
                <template v-slot:label v-if="type != 'view'">
                  Address <span class="requiredIconSpan">*</span>
                  <span class="labelSpan">(please fill in Eircode first)</span>
                </template>
                <p v-if="invalid_address" class="error_validation_message_p">
                  Please enter address
                </p>
                <b-form-textarea
                  v-if="type == 'add' || type == 'edit'"
                  id="dropoff_address"
                  class="form-control-doorder"
                  v-model="_dropoff_address"
                  name="dropoff_address"
                  placeholder="Address"
                  rows="3"
                  required
                  >{{ _dropoff_address }}</b-form-textarea
                >
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _dropoff_address }}
                </span>

                <input
                  id="dropoff_latitude"
                  name="dropoff_latitude"
                  v-model="_dropoff_latitude"
                  type="hidden"
                />
                <input
                  id="dropoff_longitude"
                  name="dropoff_longitude"
                  v-model="_dropoff_longitude"
                  type="hidden"
                />
              </b-form-group>
            </b-col>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Postcode/Eircode"
                label-for="dropoff_eircode"
                label-class="form-label-doorder"
              >
                <template v-slot:label v-if="type != 'view'">
                  Eircode <span class="requiredIconSpan">*</span>
                  <span class="labelSpan">(choose Eircode in drop down)</span>
                </template>
                <p v-if="invalid_post_code" class="error_validation_message_p">
                  Please select postcode
                </p>
                <p
                  v-if="invalid_dropoff_longitude || invalid_dropoff_latitude"
                  class="error_validation_message_p"
                >
                  Please select correct postcode
                </p>
                <!-- <vue-google-autocomplete
                  v-if="type == 'add' || type == 'edit'"
                  id="dropoff_eircode"
                  classname="form-control form-control-doorder h-auto"
                  placeholder="Postcode/Eircode"
                  types="postal_code"
                  v-model="_dropoff_eircode"
                  :country="map_countries"
                  v-on:placechanged="savePlace"
                  v-on:error="handleError"
                  v-on:inputChange="inputChange"
                  v-on:change="changeT('dropoff_eircode')"
                  required
                >
                </vue-google-autocomplete> -->
                <gmap-autocomplete
                  v-if="type == 'add' || type == 'edit'"
                  @place_changed="updatePlace"
                  class="form-control form-control-doorder h-auto"
                  :country="map_countries"
                  id="dropoff_eircode_input"
                  name="dropoff_eircode"
                  placeholder="Postcode/Eircode"
                  :componentRestrictions="componentRestrictions"
                ></gmap-autocomplete>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _dropoff_eircode }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";

export default {
  name: "CustomerDetails",
  components: {},
  props: [
    "type",
    "order_number",
    "status",
    "status_str",
    "customer_name",
    "first_name",
    "last_name",
    "email",
    "contact_number",

    "dropoff_address",
    "dropoff_eircode",
    "dropoff_latitude",
    "dropoff_longitude",

    "invalid_first_name",
    "invalid_last_name",
    "invalid_email",
    "invalid_contact_number",
    "invalid_address",
    "invalid_post_code",
    "invalid_dropoff_latitude",
    "invalid_dropoff_longitude",
  ],
  data() {
    return {
      map_countries: ["ie", "gb", "eg"],
      map_types: ["postal_code"],
      componentRestrictions: {},
      autocompleteOptions: {
        componentRestrictions: {
          country: ["ie", "gb"],
        },
        types: ["postal_code"],
      },
    };
  },
  beforeMount() {
    let map_countries_str = process.env.MAP_COUNTRIES;
    this.map_countries = map_countries_str.split(",");
    console.log(this.map_countries);
    this.componentRestrictions.country = map_countries_str.split(",");
    console.log(this.componentRestrictions);
  },
  mounted() {
    console.log(this.map_countries);
  },
  computed: {
    _first_name: {
      get() {
        return this.first_name;
      },
      set(value) {
        this.$emit("update:first_name", value);
      },
    },
    _last_name: {
      get() {
        return this.last_name;
      },
      set(value) {
        this.$emit("update:last_name", value);
      },
    },
    _email: {
      get() {
        return this.email;
      },
      set(value) {
        this.$emit("update:email", value);
      },
    },
    _contact_number: {
      get() {
        return this.contact_number;
      },
      set(value) {
        this.$emit("update:contact_number", value);
      },
    },
    _dropoff_address: {
      get() {
        return this.dropoff_address;
      },
      set(value) {
        this.$emit("update:dropoff_address", value);
      },
    },
    _dropoff_latitude: {
      get() {
        return this.dropoff_latitude;
      },
      set(value) {
        this.$emit("update:dropoff_latitude", value);
      },
    },
    _dropoff_longitude: {
      get() {
        return this.dropoff_longitude;
      },
      set(value) {
        this.$emit("update:dropoff_longitude", value);
      },
    },
    _dropoff_eircode: {
      get() {
        return this.dropoff_eircode;
      },
      set(value) {
        this.$emit("update:dropoff_eircode", value);
      },
    },
  },
  methods: {
    inputChange(place, id) {
      // console.log(place);
      // console.log(id);
      // this.dropoff_eircode = place.newVal;
      this.$emit("update:dropoff_eircode", place.newVal);
    },
    changeT(id) {
      // console.log(id);
      // console.log();
      // this.dropoff_eircode = $("#" + id).val();
      this.$emit("update:dropoff_eircode", $("#" + id).val());
    },
    savePlace(place, placeResultData, id) {
      // console.log(place);
      // console.log(placeResultData);
      // console.log(id);
      // console.log(place.latitude, place.longitude);
      // console.log(
      //   placeResultData.geometry.location.lat(),
      //   placeResultData.geometry.location.lng()
      // );
      // let index = id.split("_")[2];
      // console.log(index);
      // this.dropoff_eircode = placeResultData.name;
      this.$emit("update:dropoff_eircode", placeResultData.name);
      // this.dropoff_address = placeResultData.formatted_address;
      this.$emit("update:dropoff_address", placeResultData.formatted_address);
      // this.dropoff_latitude = place.latitude;
      this.$emit("update:dropoff_latitude", place.latitude);
      // this.dropoff_longitude = place.longitude;
      this.$emit("update:dropoff_longitude", place.longitude);
      // console.log(this.locations);
      $("#" + id).val(placeResultData.name);
    },
    handleError(error) {
      alert(error);
    },
    updatePlace(place) {
      console.log(place);
      $("#dropoff_eircode_input").val(place.name);
      this.$emit("update:dropoff_eircode", place.name);
      this.$emit("update:dropoff_address", place.formatted_address);
      console.log(place.geometry.location.lat());
      console.log(place.geometry.location.lng());
      // this.dropoff_latitude = place.latitude;
      this.$emit("update:dropoff_latitude", place.geometry.location.lat());
      // this.dropoff_longitude = place.longitude;
      this.$emit("update:dropoff_longitude", place.geometry.location.lng());
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/orders/order_details_components/CustomerDetails.vue